import { Skeleton } from '@mui/material';
import { Box } from '@mui/material';
import { getSGRWarrantyRequestFile } from 'lib/api/sgr';
import AlertBanner from 'lib/designSystem/AlertBanner';
import { Warranty } from 'lib/types/models';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

interface FileProps {
  warranty: Warranty;
  skeletonHeight?: number;
}

const File: React.FC<FileProps> = ({ warranty, skeletonHeight = 600 }) => {
  const dispatch = useDispatch();
  const { data, isPending, error } = getSGRWarrantyRequestFile(
    dispatch,
    warranty.id,
  );

  const url = useMemo(() => {
    if (!data) return null;
    const baseUrl = URL.createObjectURL(data);
    return `${baseUrl}#pagemode=none`;
  }, [data]);

  const notActiveStates = ['REJECTED', 'CANCELLED', 'CLAIMED'];

  if (notActiveStates.includes(warranty.status)) {
    return (
      <AlertBanner
        severity="info"
        title="Certificado de fianza no disponible"
        message="El certificado de fianza no está disponible porque la fianza se encuentra en un estado no activo, como siniestrada, cancelada o rechazada."
      />
    );
  }

  if (isPending)
    return (
      <Skeleton
        variant="rectangular"
        animation="wave"
        width="100%"
        height={skeletonHeight}
        sx={{ borderRadius: 1 }}
      />
    );

  if (error || !url)
    return (
      <Box py={2}>
        <AlertBanner
          severity="error"
          title="Error"
          message={error?.message ?? ''}
        />
      </Box>
    );

  return (
    <iframe
      src={url}
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        minHeight: '600px',
      }}
      title={`Documento de Garantía ${warranty.id}`}
    />
  );
};

export default File;
